import React from "react";
import { Modal } from "react-bootstrap";
import ReactStars from "react-stars";

import { commonErr } from "../common/errors";
import { returnTrip, reviewTripByOwner } from "../../model/car";

export default class ReturnTrip extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			err: commonErr.INNIT,
			step: props.step || 0, //0: confirm, 1: return trip, 2: review form, 3: review
			errMsg: "",
			rating: 5,
			comment: "",
		};
	}

	getTrip = () => {
		this.props.getTrip(this.props.trip.id);
	};

	onRatingChange = (rating) => {
		this.setState({
			rating: rating,
		});
	};

	onCommentChange = (e) => {
		this.setState({
			comment: e.target.value,
		});
	};

	finish = () => {
		this.props.hideModal();
		this.setState({
			step: this.props.step || 0,
			err: commonErr.INNIT,
		});
		this.getTrip();
	};

	goToReturn = () => {
		this.setState({
			step: 0,
			err: commonErr.INNIT,
			errorMessage: "",
		});
	};

	returnTrip = () => {
		returnTrip(this.props.trip.id).then((resp) => {
			this.setState({
				step: 1,
				err: resp.data.error,
				errMsg: resp.data.errorMessage,
			});
		});
	};

	goToReview = () => {
		this.setState({
			step: 2,
			err: commonErr.INNIT,
		});
	};

	review = () => {
		reviewTripByOwner(this.props.trip.id, this.state.rating, this.state.comment).then((resp) => {
			this.setState({
				step: 3,
				err: resp.data.error,
				errMsg: resp.data.errorMessage,
			});
		});
	};

	render() {
		var content;
		var isSD = this.props.trip.serviceType === 1;
		if (this.state.step === 3) {
			if (this.state.err >= commonErr.SUCCESS) {
				content = (
					<div className="modal-confirm-body">
						<p className="font-14">Đánh giá thành công</p>
						<div className="wrap-btn">
							<a className="btn btn-primary btn--m" onClick={this.finish}>
								Thoát
							</a>
						</div>
					</div>
				);
			} else {
				content = (
					<div className="modal-confirm-body">
						<p>{this.state.errMsg}</p>
						<div className="wrap-btn">
							<a className="btn btn-primary btn--m" onClick={this.goToReview}>
								Thử lại
							</a>
						</div>
					</div>
				);
			}
		} else if (this.state.step === 2) {
			content = (
				<React.Fragment>
					<div className="modal-confirm-body modal-trip-review-body">
						<p className="font-14">
							Hãy chia sẻ trải nghiệm của bạn về chuyến xe để giúp mọi người có sự lựa chọn tốt nhất nhé!
						</p>
						<div className="d-flex-center">
							<ReactStars
								count={5}
								size={30}
								value={this.state.rating}
								half={false}
								onChange={this.onRatingChange}
								color1={"#efefef"}
								color2={"#ffc634"}
							/>
						</div>
						<div className="custom-textarea">
							<textarea
								className="textarea"
								onChange={this.onCommentChange}
								placeholder="Nhập nội dung đánh giá"
								value={this.state.comment}></textarea>
						</div>
						<div className="wrap-btn has-2-btn">
							<a className="btn btn-primary btn--m" onClick={this.review}>
								Đánh giá
							</a>
							<a className="btn btn-link" onClick={this.finish}>
								Thoát
							</a>
						</div>
					</div>
				</React.Fragment>
			);
		} else if (this.state.step === 1) {
			if (this.state.err >= commonErr.SUCCESS) {
				content = (
					<div className="modal-confirm-body">
						<p className="font-14">Hệ thống đã cập nhật</p>
						<div className="wrap-btn has-2-btn">
							<a className="btn btn-primary btn--m" onClick={this.goToReview}>
								Đánh giá
							</a>
							<a className="btn btn-link" onClick={this.finish}>
								Thoát
							</a>
						</div>
					</div>
				);
			} else {
				content = (
					<div className="modal-confirm-body">
						<p className="font-14">
							{this.state.err === -15000 ? "Không thể trả xe trước thời gian kết thúc 16 tiếng." : this.state.errMsg}
						</p>
						<div className="wrap-btn has-2-btn">
							<a className="btn btn-primary btn--m" onClick={this.goToReturn}>
								Thử lại
							</a>
							<a className="btn btn-link" onClick={this.finish}>
								Thoát
							</a>
						</div>
					</div>
				);
			}
		} else {
			content = (
				<div className="modal-confirm-body">
					<p className="font-14">Bạn đã {isSD ? "nhận lại xe từ khách hàng" : "trả khách"}?</p>
					<div className="wrap-btn">
						<a className="btn btn-primary btn--m" onClick={this.returnTrip}>
							Xác nhận
						</a>
					</div>
				</div>
			);
		}

		return (
			<Modal show={this.props.show} onHide={this.finish} dialogClassName="modal-s modal-confirm">
				<Modal.Header closeButton={true} closeLabel={""}>
					<h5>{this.state.step >= 2 ? "Đánh giá chuyến" : "Xác nhận khách trả xe"}</h5>
				</Modal.Header>
				<Modal.Body>{content}</Modal.Body>
			</Modal>
		);
	}
}
